module.exports = __webpack_public_path__ + "img/未入会-卡面系统预设@2x.f520a2aa.png";